import React, { useState, useEffect } from 'react';
import { Building2, FileText, Users, DollarSign, AlertTriangle, BarChart, Settings, Plus, MapPin, Calendar, Phone, LayoutDashboard } from 'lucide-react';
import { motion } from 'framer-motion';
import Overview from './components/overview/Overview';
import Properties from './components/properties/Properties';
import Rentals from './components/rentals/Rentals';
import Tenants from './components/tenants/Tenants';
import Invoices from './components/invoices/Invoices';
import Issues from './components/issues/Issues';
import Analytics from './components/analytics/Analytics';
import Reports from './components/reports/Reports';
import ResSettings from './components/settings/ResSettings';
import Map from './components/map/Map';

const ResDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'Overview', icon: LayoutDashboard },
    { id: 'properties', label: 'Properties', icon: Building2 },
    { id: 'map', label: 'Map', icon: MapPin },
    { id: 'rentals', label: 'Rentals & Contracts', icon: FileText },
    { id: 'tenants', label: 'Tenants', icon: Users },
    { id: 'invoices', label: 'Invoices', icon: DollarSign },
    { id: 'issues', label: 'Issues & Tickets', icon: AlertTriangle },
    { id: 'analytics', label: 'Analytics', icon: BarChart },
    { id: 'reports', label: 'Reports', icon: FileText },
    { id: 'settings', label: 'Settings', icon: Settings }
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-amber-600 to-orange-600 rounded-xl p-6 text-white">
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-2xl font-semibold">Real Estate Management</h1>
            <p className="text-amber-100 mt-1">
              Manage properties, rentals, tenants, contracts, and invoices
            </p>
          </div>
          <div className="flex gap-3">
            <button
              onClick={() => {
                setActiveTab('properties');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="px-4 py-2 bg-white text-amber-700 rounded-lg hover:bg-amber-50 transition-colors flex items-center gap-2 font-medium"
            >
              <Plus className="w-5 h-5" />
              New Property
            </button>
          </div>
        </div>

        {/* Centered Tabs */}
        <div className="mt-6 flex justify-center overflow-x-auto">
          <div className="inline-flex space-x-1 bg-white/10 rounded-lg p-1 backdrop-blur-sm whitespace-nowrap">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap flex-shrink-0 ${
                    activeTab === tab.id
                      ? 'bg-white text-amber-700'
                      : 'text-white/90 hover:bg-white/10'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="space-y-6">
        {activeTab === 'overview' && <Overview />}
        {activeTab === 'properties' && <Properties />}
        {activeTab === 'map' && <Map />}
        {activeTab === 'rentals' && <Rentals />}
        {activeTab === 'tenants' && <Tenants />}
        {activeTab === 'invoices' && <Invoices />}
        {activeTab === 'issues' && <Issues />}
        {activeTab === 'analytics' && <Analytics />}
        {activeTab === 'reports' && <Reports />}
        {activeTab === 'settings' && <ResSettings />}
      </div>
    </div>
  );
};

export default ResDashboard;
